import { ClockCountdown } from "@phosphor-icons/react";
import { usePortfolio } from "@/context/ProfileContext";
import { TspUpdateButton } from "@/components/TspUpdate";
import { daysSince, isStale, lastSharesUpdate, tspHoldings } from "@/lib/tspUpdate";

export function TspUpdateNudge() {
  const { dash } = usePortfolio();
  if (!dash || !tspHoldings(dash).length) return null;
  const last = lastSharesUpdate(dash);
  const days = daysSince(last);
  const stale = isStale(dash);
  return (
    <div className={`glass p-4 mb-6 flex flex-wrap items-center justify-between gap-3 ${stale ? "border-amber-300 dark:border-amber-700" : ""}`} data-testid="tsp-update-nudge">
      <p className="flex items-center gap-2 text-sm">
        <ClockCountdown size={18} className={stale ? "text-amber-600" : "text-emerald-600"} />
        <span data-testid="tsp-last-updated">TSP shares last updated {last ? `${last.toLocaleDateString()} (${days} day${days === 1 ? "" : "s"} ago)` : "never"}.</span>
        {stale && <span className="font-medium text-amber-700 dark:text-amber-400" data-testid="tsp-stale-warning">Time for a quick check on TSP.gov.</span>}
      </p>
      <TspUpdateButton variant={stale ? "default" : "outline"} size="sm" testid="dashboard-tsp-update-button" />
    </div>
  );
}
